import Store from 'redux/store';
import {
  FETCH_AVAILABILITY_FAIL,
  FETCH_AVAILABILITY_SUCCESS,
} from 'redux/Reducers/Availability/AvailabilityReducer';
import { cloudloyalty } from '../clients';
import { fetchFromCacheOrAPI } from '../fetchFromCacheOrAPI';
import PipeProviderStateSingleton from '../../Providers/PipeProvider/PipeProviderState.singleton';
import generateUUID from '../../../Utils/generateUUID';

export async function fetchAvailability(User, sku, originalId, vendorId,) {
  return await cloudloyalty(User).get(`/v1/products/skus/${sku}/availability?originalId=${originalId}&vendorId=${vendorId}`);
}

const fetchAvailabilityAPI = async (User, sku, originalId, vendorId, name, callback) => {
  try {
    const response = await fetchAvailability(User, sku, originalId, vendorId)
    if (callback) callback(response)
    PipeSingleton.appendInGroupResponse('AVAILABILITY_GROUP', name, { response, sku })
    return response;
  } catch (e) {
    throw e;
  }
};
const processAvailability = (response) => {
  Store.dispatch({
    type: FETCH_AVAILABILITY_SUCCESS,
    payload: {
      response,
    },
  });
};

const PipeSingleton = new PipeProviderStateSingleton()
PipeSingleton.addReturnCallbackGroup('AVAILABILITY_GROUP', (responses) => {
  processAvailability(responses)
})

const handlePipeSingleton = () => {
  const name = generateUUID()
  PipeSingleton.appendInGroupRequest('AVAILABILITY_GROUP', name);
  return name;
}

export const FetchAvailability = async (User, finallyCallback = () => { }, { sku, originalId, vendorId, callback }) => {
  const name = handlePipeSingleton()
  try {
    await fetchFromCacheOrAPI(`FETCH_AVAILABILITY_${sku}`, () => fetchAvailabilityAPI(User, sku, originalId, vendorId, name, callback));
  } catch (e) {
    if (callback) callback(null, e);
    PipeSingleton.appendInGroupResponse('AVAILABILITY_GROUP', name, {
      response: {
        data: [{
          available: false,
          error: e,
        }]
      }, sku
    })
    Store.dispatch({
      type: FETCH_AVAILABILITY_FAIL,
      error: e,
      payload: {
        sku,
      },
    });
  } finally {
    PipeSingleton.executeCallbackForGroup('AVAILABILITY_GROUP', () => {
      finallyCallback();
    })
  }
};

export const getAvailability = (User, sku, originalId, vendorId) => {
  return new Promise((resolve, reject) => {
    cloudloyalty(User)
      .get(`/v1/products/skus/${sku}/availability?originalId=${originalId}&vendorId=${vendorId}`)
      .then((data) => {
        resolve(data)
      }
      )
      .catch((err) => {
        reject(err);
      });
  });
};